import { useEffect, ReactNode } from 'react'
import { useStatusStore } from '@/stores/statusStore'
import { getSystemStatusApi } from '@/api/status'

/**
 * 全局系统状态提供者：应用启动时拉取 /api/status
 * 同时把 quota_per_unit、display_in_currency 等写入 localStorage
 */
export function StatusProvider({ children }: { children: ReactNode }) {
  const { setStatus, setLoading, loaded, loading } = useStatusStore()

  useEffect(() => {
    if (loaded || loading) return
    setLoading(true)
    getSystemStatusApi()
      .then((data) => {
        setStatus(data || {})
      })
      .catch((err) => {
        console.error('Failed to load system status:', err)
        setStatus({})
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <>{children}</>
}
